// projects/humanresources-personnel/src/assets/i18n/*/hr-per-identity.json
export class HrPerIdentityKey {
    private static readonly keyPrefix = 'hrPerIdentity';
    public static title = `${HrPerIdentityKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerIdentityKey.keyPrefix}.pageHeader`;
    public static number = `${HrPerIdentityKey.keyPrefix}.number`;
    public static identityName = `${HrPerIdentityKey.keyPrefix}.identityName`;
    public static surname = `${HrPerIdentityKey.keyPrefix}.surname`;
    public static maidenName = `${HrPerIdentityKey.keyPrefix}.maidenName`;
    public static fatherName = `${HrPerIdentityKey.keyPrefix}.fatherName`;
    public static motherName = `${HrPerIdentityKey.keyPrefix}.motherName`;
    public static birthDate = `${HrPerIdentityKey.keyPrefix}.birthDate`;
    public static placeOfBirth = `${HrPerIdentityKey.keyPrefix}.placeOfBirth`;
    public static gender = `${HrPerIdentityKey.keyPrefix}.gender`;
    public static genders = `${HrPerIdentityKey.keyPrefix}.genders`;
    public static statusEnum = `${HrPerIdentityKey.keyPrefix}.statusEnum`;
    public static hrmMaritalStatusUuid = `${HrPerIdentityKey.keyPrefix}.hrmMaritalStatusUuid`;
    public static subDistrictVillage = `${HrPerIdentityKey.keyPrefix}.subDistrictVillage`;
    public static volumeNumber = `${HrPerIdentityKey.keyPrefix}.volumeNumber`;
    public static familyOrder = `${HrPerIdentityKey.keyPrefix}.familyOrder`;
    public static orderNumber = `${HrPerIdentityKey.keyPrefix}.orderNumber`;
    public static placeOfIssue = `${HrPerIdentityKey.keyPrefix}.placeOfIssue`;
    public static registrationNumber = `${HrPerIdentityKey.keyPrefix}.registrationNumber`;
    public static dateOfIssue = `${HrPerIdentityKey.keyPrefix}.dateOfIssue`;
    public static validUntil = `${HrPerIdentityKey.keyPrefix}.validUntil`;
    public static serial = `${HrPerIdentityKey.keyPrefix}.serial`;
    public static serialNumber = `${HrPerIdentityKey.keyPrefix}.serialNumber`;
    public static status = `${HrPerIdentityKey.keyPrefix}.status`;
    public static reasonOfIssue = `${HrPerIdentityKey.keyPrefix}.reasonOfIssue`;
}
